import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Colors } from "helpers/colors";

export const CloseIcon: React.FC = () => (
  <CloseOutlined style={{ fontSize: "20px", color: Colors.Grey }} />
);
